import { TabBar } from '@cogneed/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import usePrevious from '../../../../../Hooks/usePrevious';
import useSessionContext from '../../../../LiveContext/SessionContextProvider/useSessionContext';
import StyledBox from './styles';

const TAB_VALUES = ['historique', 'conformite'];

interface PanelTabsProps {
  index: number;
  setIndex: (value: number) => void;
}

// Plain tab switcher matching the mockup -- per-tab unseen-count badges
// moved into each panel's own header (see DetectionList/CompliancePanel),
// so the tabs themselves stay unbadged here.
export default function PanelTabs(props: PanelTabsProps) {
  const { index, setIndex } = props;
  const { compliance, session } = useSessionContext();
  const { t } = useTranslation();
  const [initialized, setInitialised] = React.useState(false);
  const previousComplianceLength = usePrevious(compliance.length);

  React.useEffect(() => {
    if (!session) {
      setInitialised(false);
    }
  }, [!!session]);

  React.useEffect(() => {
    if (compliance.length && !initialized) {
      setIndex(1);
      setInitialised(true);
    } else if (compliance.length > previousComplianceLength && index !== 1) {
      setIndex(1);
    }
  }, [compliance.length, previousComplianceLength, initialized]);

  const items = [
    { value: 'historique', label: t('right-panel.session-history.title') },
    { value: 'conformite', label: t('right-panel.session-compliance.title') },
  ];

  return (
    <StyledBox>
      <TabBar
        items={items}
        value={TAB_VALUES[index]}
        onChange={(value) => setIndex(TAB_VALUES.indexOf(value))}
      />
    </StyledBox>
  );
}
